import { Box } from "../../../components/box";
import List from "devextreme-react/list";
import { Icon } from "../../../modules/icon";
import { useHistory } from "react-router-dom";
import { Routes } from "../../../AppRoutes";
import { NotifyDetails } from "./notify-details";
import { useNotfiy } from "../hooks/use-notify";
import { Spin } from "antd";
import { useSearchParams } from "../../../hook/use-search-params";
import { useUpdateNotify } from "../hooks/use-update-notify";

const searchExpr = ["content", "title", "timeReceived"];
const listAttrs = { class: "list" };

export const NotifyList: React.FC = () => {
  const history = useHistory();
  const { notifyToMeData, isLoading } = useNotfiy();
  const { searchParams, replaceSearchParams } = useSearchParams();
  const { updateNotify } = useUpdateNotify();
  const notifyId = searchParams.get("notifyId");

  const handleRenderListItems = (e: any) => {
    return <p className={e.viewed ? "" : "font-weight-bold"}>{e.title}</p>;
  };

  const handleItemClick = (e: any) => {
    searchParams.set("notifyId", e.itemData.id);
    replaceSearchParams(searchParams);

    if (!e?.itemData?.viewed) {
      const id = e?.itemData?.id;
      const fields = { Status: true };
      updateNotify({ id: id, fields: fields });
    }
  };

  const getBackLink = () => {
    return history.push(Routes.document.path);
  };

  if (isLoading) return <Spin />;

  return (
    <>
      <div>
        <div className="pd0">
          <div title={"Trở về trang Danh sách tài liệu"} className="btnBack mb-4" onClick={() => getBackLink()}>
            <Icon.ArrowLeft />
          </div>
          <Box className="full__notify-content" title="Danh sách thông báo">
            <div className="content__notify-left">
              <List
                selectionMode="single"
                dataSource={notifyToMeData}
                displayExpr="title"
                className="Notification__list"
                searchEnabled={true}
                searchEditorOptions={{ height: 40 }}
                searchExpr={searchExpr}
                style={{ fontFamily: "Source Sans Pro" }}
                elementAttr={listAttrs}
                itemRender={handleRenderListItems}
                onItemClick={handleItemClick}
                keyExpr="id"
                defaultSelectedItemKeys={notifyId}
                nextButtonText="Xem thêm"
                height={"100%"}
                showScrollbar="always"
              />
            </div>
            <NotifyDetails />
          </Box>
        </div>
      </div>
    </>
  );
};
